export function get12HourTimeLabel(time: string, space = ' '): string {
    const [ rawHour, rawMinute ] = time.split(':');
    const hour = parseInt(rawHour, 10);
    const minute = parseInt(rawMinute, 10);
    const hour12 = hour === 0 || hour === 12 ? 12 : hour < 12 ? hour : hour - 12;
    const suffix = hour < 12 ? 'am' : 'pm';
    return `${hour12}:${`${minute}`.padStart(2, '0')}${space}${suffix}`;
}
